import { axios } from "./index";

const base = "eiv";

class EIVAPI {
  // GET /eiv/weekly-facility-metrics?facility=XXX&week=YY&year=ZZ
  static GetWeeklyFacilityMetrics = (facility, week, year) => {
    return axios.get(`${base}/weekly-facility-metrics`, {
      params: { facility, week, year },
    });
  };

  // GET /eiv/weekly-facility-insurance-metrics?facility=XXX&week=YY&year=ZZ
  static GetWeeklyFacilityInsuranceMetrics = (facility, week, year) => {
    return axios.get(`${base}/weekly-facility-insurance-metrics`, {
      params: { facility, week, year },
    });
  };

  // GET /eiv/weekly-facility-insurance-loc-metrics?facility=XXX&week=YY&year=ZZ
  static GetWeeklyFacilityInsuranceLocMetrics = (facility, week, year) => {
    return axios.get(`${base}/weekly-facility-insurance-loc-metrics`, {
      params: { facility, week, year },
    });
  };

  // GET /eiv/weekly-facility-loc-counts?facility=XXX&week=YY&year=ZZ
  static GetWeeklyFacilityLocCounts = (facility, week, year) => {
    return axios.get(`${base}/weekly-facility-loc-counts`, {
      params: { facility, week, year },
    });
  };

  // GET /eiv/last-week-for-facility?facility=XXX
  static GetLastWeekForFacility = (facility) => {
    return axios.get(`${base}/last-week-for-facility`, {
      params: { facility },
    });
  };
}

export default EIVAPI;
